import { Currency } from '@/core/currency/interfaces';

const KES: Currency = {
    name: 'Kenyan Shilling',
    demonym: 'Kenyan',
    majorSingle: 'Shilling',
    majorPlural: 'Shillings',
    codeNumeric: '404',
    symbol: 'KSh',
    symbolNative: 'KSh',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'KES',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default KES;
